import { ROUTE_PARTIES_ADD, ROUTE_PARTIES_EDIT } from '@/common/constants';
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { IParty } from '../models';
import { PartiesSchema } from '../schema';
import { usePartyStore } from '../store/usePartyStore';

export const useParties = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { addParty, fetchParties, fetchParty, updateParty, isLoading } =
    usePartyStore();
  const { id } = useParams();
  const form = useForm({
    resolver: yupResolver(PartiesSchema),
  });

  const type = useMemo(() => {
    if (pathname.includes(ROUTE_PARTIES_ADD)) {
      return 'add';
    } else if (pathname.includes(ROUTE_PARTIES_EDIT)) {
      return 'edit';
    }
  }, [pathname]);

  const fetchSingle = async () => {
    if (type === 'edit' && id) {
      const data: IParty = await fetchParty(id!);
      form.reset({
        place_number: data?.place_number,
        party_number: data?.party_number,
        crop_type_id: data?.crop_type_id,
        cluster_id: data?.cluster_id,
        generation: data?.generation,
        crop_generation_id:
          data?.generation === 'TECHNICAL'
            ? undefined
            : data?.crop_generation_id,
        industrial_grade: data?.industrial_grade,
        class: data?.class,
        capacity: data?.capacity,
      });
    }
  };

  useEffect(() => {
    fetchSingle();
  }, [type]);

  const onSubmit = async (data: any) => {
    if (type === 'edit' && id) {
      await updateParty(id, data);
    } else {
      await addParty(data);
    }
    fetchParties();
    form.reset();
    navigate(-1);
  };

  const handleForm = form.handleSubmit(onSubmit);

  return {
    type,
    form,
    onSubmit: handleForm,
    isLoading,
  };
};
